// extracted by mini-css-extract-plugin
module.exports = {"thumb_srcset":"DisplayThumbImage_thumb_srcset__FH5jH","show_fallback_image":"DisplayThumbImage_show_fallback_image__T9bUy"};